var _router = null;
export default {
  set: (router) => _router = router,
  get: () => _router
}
